import { PayoffSchedule } from '../model/interfaces/payoff-schedule.interface';
import { ProductSummary } from '../model/interfaces/product-summary.interface';
import { MapPayoffScheduleToDate } from './map-payoff-schedule-to-date';

export function GetPayoffStringToDate(summary: ProductSummary): ProductSummary {
  const out = {
    ...summary,
    schedule: {
      scheduleStrategy: summary?.schedule?.scheduleStrategy,
      coupon: {
        ...summary?.schedule?.coupon,
        schedule: MapPayoffScheduleToDate(summary?.schedule?.coupon?.schedule as PayoffSchedule[]),
      },
      earlyRedemption: {
        ...summary?.schedule?.earlyRedemption,
        schedule: MapPayoffScheduleToDate(summary?.schedule?.earlyRedemption?.schedule as PayoffSchedule[]),
      },
      participation: {
        ...summary?.schedule.participation,
        upside: {
          ...summary?.schedule.participation?.upside,
          schedule: MapPayoffScheduleToDate(summary?.schedule.participation?.upside?.schedule as PayoffSchedule[]),
        },
        downside: {
          ...summary?.schedule.participation?.downside,
          schedule: MapPayoffScheduleToDate(summary?.schedule.participation?.downside?.schedule as PayoffSchedule[]),
        },
        base: {
          ...summary?.schedule.participation?.base,
          schedule: MapPayoffScheduleToDate(summary?.schedule.participation?.base?.schedule as PayoffSchedule[]),
        },
      },
    }
  } as ProductSummary;
  return out;
}
